import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X2AgeCategoryStore} from '../X2AgeCategoryStore';

@observer
export class DeleteLevelControls extends React.Component<{ store: X2AgeCategoryStore }> {
  render() {
    const {store} = this.props;

    if (store.deleteLevel === null)
      return null;

    const deleteLevel = store.deleteLevel;
    const isFailure = deleteLevel.save?.isRejected === true;

    return (<>
      <PromiseMessage label="Deleting" state={deleteLevel.save} align="right"/>
      {
        isFailure &&
        <div className="row justify-content-end">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={() => store.beginDelete(deleteLevel.levelId)}> Retry
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={store.cancel}> Cancel
            </button>
          </div>
        </div>
      }
    </>);
  }
}
